import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "w-full overflow-y-auto rounded-lg bg-eblack-100/70" };
const _hoisted_2 = { class: "flex flex-col flex-1 p-3 overflow-y-auto gap-y-3" };
const _hoisted_3 = { class: "text-sm text-white md:text-md" };
const _hoisted_4 = {
    key: 1,
    class: "space-y-2"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "text-base font-medium text-gray-900 dark:text-white"
};
const _hoisted_7 = {
    key: 1,
    class: "text-base font-medium text-gray-900 dark:text-white"
};
const _hoisted_8 = {
    key: 2,
    class: "text-base font-medium text-gray-900 dark:text-white"
};
const _hoisted_9 = { class: "text-xs text-gray-500 dark:text-gray-300 mt-0.5" };
const _hoisted_10 = ["onClick", "title"];
const _hoisted_11 = { class: "flex flex-col gap-y-2" };
const _hoisted_12 = {
    for: "provider_id",
    class: "text-sm md:text-md"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { value: "0" };
const _hoisted_15 = ["value"];
const _hoisted_16 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_17 = { class: "flex flex-col gap-y-2" };
const _hoisted_18 = {
    for: "service_type_id",
    class: "text-sm md:text-md"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = { value: null };
const _hoisted_21 = ["value"];
const _hoisted_22 = { class: "text-xs text-gray-500" };
const _hoisted_23 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_24 = { class: "flex flex-col gap-y-2" };
const _hoisted_25 = {
    for: "name",
    class: "text-sm md:text-md"
};
const _hoisted_26 = ["placeholder", "disabled"];
const _hoisted_27 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_28 = { class: "mt-6 p-4 bg-white rounded-lg border border-gray-200" };
const _hoisted_29 = { class: "text-lg font-medium text-eblack-900 mb-4" };
const _hoisted_30 = { class: "flex flex-col gap-y-4" };
const _hoisted_31 = { class: "flex flex-col gap-y-2" };
const _hoisted_32 = {
    for: "cancellation_policy_duration",
    class: "text-sm md:text-md font-medium"
};
const _hoisted_33 = ["disabled", "placeholder"];
const _hoisted_34 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_35 = { class: "flex flex-col gap-y-2" };
const _hoisted_36 = {
    for: "min_time_booking",
    class: "text-sm md:text-md font-medium"
};
const _hoisted_37 = ["disabled"];
const _hoisted_38 = { class: "text-xs text-gray-500" };
const _hoisted_39 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_40 = { class: "flex flex-col gap-y-2" };
const _hoisted_41 = {
    for: "max_time_booking",
    class: "text-sm md:text-md font-medium"
};
const _hoisted_42 = ["disabled"];
const _hoisted_43 = { class: "text-xs text-gray-500" };
const _hoisted_44 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_45 = { class: "flex flex-col gap-y-2" };
const _hoisted_46 = {
    for: "duration",
    class: "text-sm md:text-md"
};
const _hoisted_47 = ["disabled"];
const _hoisted_48 = { class: "text-xs" };
const _hoisted_49 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_50 = { class: "flex flex-col gap-y-2" };
const _hoisted_51 = {
    for: "country",
    class: "text-sm md:text-md"
};
const _hoisted_52 = ["disabled"];
const _hoisted_53 = { value: "" };
const _hoisted_54 = ["value"];
const _hoisted_55 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_56 = {
    key: 0,
    class: "flex flex-col gap-y-4"
};
const _hoisted_57 = {
    key: 0,
    class: "flex flex-col gap-y-2"
};
const _hoisted_58 = {
    for: "location_one",
    class: "text-sm md:text-md"
};
const _hoisted_59 = ["disabled"];
const _hoisted_60 = { value: "" };
const _hoisted_61 = ["value"];
const _hoisted_62 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_63 = {
    key: 1,
    class: "flex flex-col gap-y-2"
};
const _hoisted_64 = {
    for: "location_two",
    class: "text-sm md:text-md"
};
const _hoisted_65 = ["disabled"];
const _hoisted_66 = { value: "" };
const _hoisted_67 = ["value"];
const _hoisted_68 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_69 = {
    key: 1,
    class: "flex flex-col gap-y-4"
};
const _hoisted_70 = {
    key: 0,
    class: "flex flex-col gap-y-2"
};
const _hoisted_71 = {
    for: "location_one",
    class: "text-sm md:text-md"
};
const _hoisted_72 = ["disabled"];
const _hoisted_73 = ["value"];
const _hoisted_74 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_75 = {
    key: 1,
    class: "flex flex-col gap-y-2"
};
const _hoisted_76 = {
    for: "location_two",
    class: "text-sm md:text-md"
};
const _hoisted_77 = ["disabled"];
const _hoisted_78 = ["value"];
const _hoisted_79 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_80 = { class: "flex flex-col gap-y-2" };
const _hoisted_81 = {
    for: "category_id",
    class: "text-sm md:text-md"
};
const _hoisted_82 = { class: "text-xs text-gray-400" };
const _hoisted_83 = ["disabled"];
const _hoisted_84 = { value: null };
const _hoisted_85 = ["value"];
const _hoisted_86 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_87 = {
    key: 1,
    class: "pl-2 text-xs text-red-500 md:text-sm"
};
const _hoisted_88 = { class: "flex flex-col gap-y-2" };
const _hoisted_89 = {
    for: "message",
    class: "text-sm"
};
const _hoisted_90 = ["placeholder", "disabled"];
const _hoisted_91 = {
    key: 0,
    class: "pl-2 text-xs text-red-400 md:text-sm"
};
const _hoisted_92 = { class: "flex flex-col gap-y-2" };
const _hoisted_93 = {
    for: "additional_information",
    class: "text-sm"
};
const _hoisted_94 = { class: "text-gray-400 text-xs" };
const _hoisted_95 = ["placeholder", "disabled"];
import { ref, reactive, computed, watch, onMounted, onBeforeMount } from 'vue';
import data from '@/core/data';
import { DayOfWeek } from '@domains/shared/models/day-of-week.value-object';
import { useAbility, useAuthStore } from '@/domains/auth';
import { useServiceFormLookups } from '@domains/service/composables/useServiceFormLookups';
import ServiceChargesSection from '@/domains/charges/components/ServiceChargesSection.vue';
import { cloneDefaultFormValues, serviceToFormValues, } from '@domains/service/models/service-form.mapper';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormTab',
    props: {
        service: { default: null },
        errors: { default: () => [] },
        showDetails: { type: Boolean, default: false },
        readOnly: { type: Boolean, default: false },
        availabilities: { default: () => [] },
        form: { default: null }
    },
    emits: ['show-availability-modal', 'edit-availability', 'erase-availability'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const lookups = useServiceFormLookups();
        const localServiceForm = reactive(cloneDefaultFormValues());
        const serviceForm = props.form ?? localServiceForm;
        const ownsFormState = computed(() => props.form == null);
        const country_selected = ref(null);
        const countries = ref([]);
        const location_one = ref([]);
        const location_two = ref([]);
        const categories = lookups.categories;
        const categoryError = lookups.categoryError;
        const isLoadingCategories = lookups.isLoadingCategories;
        const providers = lookups.providers;
        const serviceTypes = lookups.serviceTypes;
        const loading = ref(false);
        const { can } = useAbility();
        const authStore = useAuthStore();
        const isAdmin = computed(() => can('manage', 'all'));
        const isReadOnly = computed(() => props.readOnly || props.showDetails);
        watch(() => serviceForm.country, (value) => {
            loadStates(value);
        }, { immediate: true });
        watch(() => serviceForm.location_one, (value) => {
            loadCities(value);
        }, { immediate: true });
        watch(() => props.service, (value) => {
            if (!ownsFormState.value) {
                return;
            }
            if (value) {
                Object.assign(serviceForm, serviceToFormValues(value));
            }
            else {
                resetForm();
            }
        }, { immediate: true });
        function loadStates(value) {
            const state = countries.value.filter((item) => item.iso2 == value);
            if (state.length > 0) {
                country_selected.value = state[0];
                location_one.value = state[0].states;
            }
        }
        function loadCities(value) {
            if (country_selected.value) {
                const cities = country_selected.value.states.filter((item) => item.name.toLowerCase() == value);
                if (cities.length > 0) {
                    location_two.value = cities[0].cities;
                }
            }
        }
        async function getCategories() {
            const categoryId = await lookups.loadCategories(serviceForm.category_id);
            serviceForm.category_id = categoryId ?? null;
        }
        async function getProviders() {
            await lookups.loadProviders();
            setProvider();
        }
        function setProvider() {
            if (!isAdmin.value) {
                const providerId = lookups.selectProviderForUser(serviceForm.provider_id, isAdmin.value);
                if (providerId) {
                    serviceForm.provider_id = providerId;
                }
            }
        }
        async function initData() {
            await Promise.all([
                getCategories(),
                getProviders(),
                lookups.loadServiceTypes()
            ]);
        }
        function resetForm() {
            if (ownsFormState.value) {
                Object.assign(serviceForm, cloneDefaultFormValues());
            }
        }
        function formatTitle(startingDate, endingDate) {
            const startingDay = DayOfWeek.toFullName(startingDate);
            const endingDay = DayOfWeek.toFullName(endingDate);
            return `${startingDay} a ${endingDay.toLowerCase()}`;
        }
        /**
         * Safely get the schedule data from an availability item.
         * Handles both direct schedule arrays and items where schedule data is at the root level.
         * @param {Object} item - The availability item
         * @returns {Object|null} The schedule object or null if not found
         */
        function getSchedule(item) {
            if (!item)
                return null;
            // Check if schedule array exists and has items
            if (item.schedule && Array.isArray(item.schedule) && item.schedule.length > 0) {
                const schedule = item.schedule[0];
                // Ensure the schedule has the required fields
                if (schedule && schedule.days_of_week && Array.isArray(schedule.days_of_week) && schedule.days_of_week.length > 0) {
                    return schedule;
                }
            }
            // Fallback: check if the item itself has schedule data at the root level
            if (item.days_of_week && Array.isArray(item.days_of_week) && item.days_of_week.length > 0) {
                return item;
            }
            return null;
        }
        function onEditAvailability(item, index) {
            emit('edit-availability', { item, index });
        }
        function onEraseAvailability(index) {
            emit('erase-availability', index);
        }
        onMounted(() => {
            countries.value = data.countriesStatesCities;
        });
        onBeforeMount(() => {
            initData();
        });
        watch(() => authStore.currentOrgId, (orgId, previousOrgId) => {
            if (orgId === previousOrgId)
                return;
            serviceForm.category_id = null;
            getCategories();
        });
        __expose({
            serviceForm,
            resetForm
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        (!isReadOnly.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(["bg-green-500 text-white px-2 py-1.5 rounded-lg", [loading.value ? 'animate animate-bouncing' : '']]),
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('show-availability-modal', __props.service)))
                            }, [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("services.auto.agregar_horario")), 1)
                            ], 2))
                            : _createCommentVNode("", true),
                        (__props.availabilities)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availabilities, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.title,
                                        class: "flex items-center justify-between p-3 mt-4 transition bg-white border border-gray-300 rounded-lg"
                                    }, [
                                        _createElementVNode("div", {
                                            "data-testid": "availability-card",
                                            class: "flex-1 -m-3 p-3 rounded-l-lg cursor-pointer hover:bg-gray-50",
                                            onClick: ($event) => (onEditAvailability(item, index))
                                        }, [
                                            (item.type === 'availability' && getSchedule(item))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(`${formatTitle(getSchedule(item).days_of_week[0], getSchedule(item).days_of_week[getSchedule(item).days_of_week.length - 1])} de ${getSchedule(item).start_time} a ${getSchedule(item).end_time}`), 1))
                                                : (item.type === 'availability')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("services.auto.disponibilidad_sin_configurar")), 1))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(`${item.overrideStartingFrom} a ${item.overrideUntil} de ${item.start_time} a ${item.end_time}`), 1)),
                                            _createElementVNode("div", _hoisted_9, _toDisplayString(item.type === "availability"
                                                ? _ctx.$t("services.auto.ajustes_todas_las_fechas")
                                                : item.type === "override"
                                                    ? _ctx.$t("services.auto.ajustes_rango_fechas")
                                                    : ""), 1)
                                        ], 8, _hoisted_5),
                                        (!isReadOnly.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                onClick: _withModifiers(($event) => (onEraseAvailability(index)), ["stop"]),
                                                class: "p-2 text-red-600 hover:bg-red-50 rounded-lg transition",
                                                title: _ctx.$t('services.auto.eliminar_horario')
                                            }, [...(_cache[16] || (_cache[16] = [
                                                    _createElementVNode("svg", {
                                                        class: "w-6 h-6",
                                                        "aria-hidden": "true",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            stroke: "currentColor",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "stroke-width": "2",
                                                            d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                                                        })
                                                    ], -1)
                                                ]))], 8, _hoisted_10))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("services.auto.proveedor")), 1),
                        _withDirectives(_createElementVNode("select", {
                            name: "provider_id",
                            class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.provider_id > 0 && __props.errors[1] }]),
                            placeholder: "0",
                            disabled: isReadOnly.value || !isAdmin.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(serviceForm).provider_id) = $event))
                        }, [
                            _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("services.auto.seleccione_el_proveedor")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(providers), (provider) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: provider.id,
                                    value: provider.id
                                }, _toDisplayString(provider.name), 9, _hoisted_15));
                            }), 128))
                        ], 10, _hoisted_13), [
                            [_vModelSelect, _unref(serviceForm).provider_id]
                        ]),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.provider_id))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.errors.find((e) => e.provider_id).provider_id), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("services.auto.tipo_de_servicio")), 1),
                        _withDirectives(_createElementVNode("select", {
                            name: "service_type_id",
                            class: "text-sm rounded-md md:text-md right-1 focus:ring-blue-400",
                            disabled: isReadOnly.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(serviceForm).service_type_id) = $event))
                        }, [
                            _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("services.auto.sin_tipo_especifico")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceTypes), (serviceType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: serviceType.id,
                                    value: serviceType.id
                                }, _toDisplayString(serviceType.name), 9, _hoisted_21));
                            }), 128))
                        ], 8, _hoisted_19), [
                            [_vModelSelect, _unref(serviceForm).service_type_id]
                        ]),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("services.auto.seleccione_un_tipo_si_el_servicio_requiere_campo")), 1),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.service_type_id))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(__props.errors.find((e) => e.service_type_id).service_type_id), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("services.auto.nombre")), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "name",
                            class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", {
                                    'ring-red-400': __props.errors.length > 0 && __props.errors.find((e) => e.name),
                                }]),
                            placeholder: _ctx.$t('services.auto.emanta_service'),
                            disabled: isReadOnly.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(serviceForm).name) = $event))
                        }, null, 10, _hoisted_26), [
                            [_vModelText, _unref(serviceForm).name]
                        ]),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.name))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(__props.errors.find((e) => e.name).name), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t("services.auto.configuracion_de_reservas_y_cancelaciones")), 1),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("services.auto.ventana_de_cancelacion_antes_del_servicio_dias")), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    name: "cancellation_policy_duration",
                                    class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors.find((e) => e.cancellation_policy_duration) }]),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(serviceForm).cancellation_policy_duration) = $event)),
                                    disabled: isReadOnly.value,
                                    placeholder: _ctx.$t('services.auto.ingrese_el_numero_de_dias'),
                                    min: "0",
                                    step: "1"
                                }, null, 10, _hoisted_33), [
                                    [
                                        _vModelText,
                                        _unref(serviceForm).cancellation_policy_duration,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (__props.errors.length > 0 && __props.errors.find((e) => e.cancellation_policy_duration))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(__props.errors.find((e) => e.cancellation_policy_duration).cancellation_policy_duration), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("services.auto.tiempo_minimo_para_reservar")), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    name: "min_time_booking",
                                    class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", {
                                            'ring-red-400': __props.errors.min_time_booking > 0 && __props.errors[1],
                                        }]),
                                    placeholder: "1",
                                    min: "0",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(serviceForm).min_time_booking) = $event)),
                                    disabled: isReadOnly.value
                                }, null, 10, _hoisted_37), [
                                    [_vModelText, _unref(serviceForm).min_time_booking]
                                ]),
                                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("services.auto.en_dias")), 1),
                                (__props.errors.length > 0 && __props.errors.find((e) => e.min_time_booking))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(__props.errors.find((e) => e.min_time_booking).min_time_booking), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("services.auto.tiempo_maximo_para_reservar")), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    name: "max_time_booking",
                                    class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", {
                                            'ring-red-400': __props.errors.length > 0 && __props.errors.find((e) => e.max_time_booking),
                                        }]),
                                    placeholder: "30",
                                    min: "1",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(serviceForm).max_time_booking) = $event)),
                                    disabled: isReadOnly.value
                                }, null, 10, _hoisted_42), [
                                    [_vModelText, _unref(serviceForm).max_time_booking]
                                ]),
                                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("services.auto.en_dias")), 1),
                                (__props.errors.length > 0 && __props.errors.find((e) => e.max_time_booking))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(__props.errors.find((e) => e.max_time_booking).max_time_booking), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("services.auto.duracion")), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            name: "duration",
                            class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.duration > 0 && __props.errors[1] }]),
                            placeholder: "0",
                            disabled: isReadOnly.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(serviceForm).duration) = $event))
                        }, null, 10, _hoisted_47), [
                            [_vModelText, _unref(serviceForm).duration]
                        ]),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("services.auto.en_horas")), 1),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.duration))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(__props.errors.find((e) => e.duration).duration), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("services.auto.pais")), 1),
                        _withDirectives(_createElementVNode("select", {
                            name: "country",
                            class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors[3] }]),
                            disabled: isReadOnly.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(serviceForm).country) = $event))
                        }, [
                            _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.$t("services.auto.seleccione_el_pais")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: country.id,
                                    value: country.iso2
                                }, _toDisplayString(country.name), 9, _hoisted_54));
                            }), 128))
                        ], 10, _hoisted_52), [
                            [_vModelSelect, _unref(serviceForm).country]
                        ]),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.country))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(__props.errors.find((e) => e.country).country), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (_unref(serviceForm).country == 'CR')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            (location_one.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("services.auto.provincia")), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        name: "location_one",
                                        class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors[4] }]),
                                        disabled: isReadOnly.value,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(serviceForm).location_one) = $event))
                                    }, [
                                        _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.$t("services.auto.seleccione_la_provincia")), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_one.value, (state) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: state.id,
                                                value: state.name.toLowerCase()
                                            }, _toDisplayString(state.name), 9, _hoisted_61));
                                        }), 128))
                                    ], 10, _hoisted_59), [
                                        [_vModelSelect, _unref(serviceForm).location_one]
                                    ]),
                                    (__props.errors.length > 0 && __props.errors.find((e) => e.location_one))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(__props.errors.find((e) => e.location_one).location_one), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (location_two.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("services.auto.canton")), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        name: "location_two",
                                        class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors[5] }]),
                                        disabled: isReadOnly.value,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(serviceForm).location_two) = $event))
                                    }, [
                                        _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t("services.auto.seleccione_el_canton")), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_two.value, (city) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: city.id,
                                                value: city.name.toLowerCase()
                                            }, _toDisplayString(city.name), 9, _hoisted_67));
                                        }), 128))
                                    ], 10, _hoisted_65), [
                                        [_vModelSelect, _unref(serviceForm).location_two]
                                    ]),
                                    (__props.errors.length > 0 && __props.errors.find((e) => e.location_two))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(__props.errors.find((e) => e.location_two).location_two), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            (location_one.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("services.auto.estado")), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        name: "location_one",
                                        class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors[4] }]),
                                        disabled: isReadOnly.value,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(serviceForm).location_one) = $event))
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_one.value, (state) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: state.id,
                                                value: state.name.toLowerCase().trim()
                                            }, _toDisplayString(state.name), 9, _hoisted_73));
                                        }), 128))
                                    ], 10, _hoisted_72), [
                                        [_vModelSelect, _unref(serviceForm).location_one]
                                    ]),
                                    (__props.errors.length > 0 && __props.errors.find((e) => e.location_one))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(__props.errors.find((e) => e.location_one).location_one), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (location_two.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("services.auto.ciudad")), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        name: "location_two",
                                        class: _normalizeClass(["text-sm rounded-md md:text-md right-1 focus:ring-blue-400", { 'ring-red-400': __props.errors.length > 0 && __props.errors[5] }]),
                                        disabled: isReadOnly.value,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(serviceForm).location_two) = $event))
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_two.value, (city) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: city.id,
                                                value: city.name.toLowerCase().trim()
                                            }, _toDisplayString(city.name), 9, _hoisted_78));
                                        }), 128))
                                    ], 10, _hoisted_77), [
                                        [_vModelSelect, _unref(serviceForm).location_two]
                                    ]),
                                    (__props.errors.length > 0 && __props.errors.find((e) => e.location_two))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(__props.errors.find((e) => e.location_two).location_two), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ])),
                    _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("label", _hoisted_81, [
                            _createTextVNode(_toDisplayString(_ctx.$t("services.auto.categoria")), 1),
                            _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.$t("services.auto.opcional")), 1)
                        ]),
                        _withDirectives(_createElementVNode("select", {
                            name: "category_id",
                            class: "text-sm rounded-md md:text-md right-1 focus:ring-blue-400",
                            disabled: isReadOnly.value || _unref(isLoadingCategories),
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(serviceForm).category_id) = $event))
                        }, [
                            _createElementVNode("option", _hoisted_84, _toDisplayString(_ctx.$t("services.auto.sin_categoria")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: category.id,
                                    value: category.id
                                }, _toDisplayString(category.name), 9, _hoisted_85));
                            }), 128))
                        ], 8, _hoisted_83), [
                            [_vModelSelect, _unref(serviceForm).category_id]
                        ]),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.category_id))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(__props.errors.find((e) => e.category_id).category_id), 1))
                            : _createCommentVNode("", true),
                        (_unref(categoryError))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_unref(categoryError)), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("services.auto.descripcion")), 1),
                        _withDirectives(_createElementVNode("textarea", {
                            rows: "4",
                            class: "block p-2.5 w-full text-sm bg-white rounded-lg border border-black focus:ring-blue-500 focus:border-blue-500",
                            placeholder: _ctx.$t('services.auto.escriba_de_que_trata_el_tour'),
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(serviceForm).description) = $event)),
                            disabled: isReadOnly.value
                        }, null, 8, _hoisted_90), [
                            [_vModelText, _unref(serviceForm).description]
                        ]),
                        (__props.errors.length > 0 && __props.errors.find((e) => e.description))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(__props.errors.find((e) => e.description).description), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("label", _hoisted_93, [
                            _createTextVNode(_toDisplayString(_ctx.$t("services.auto.notas_o_solicitudes_para_el_concierge")), 1),
                            _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t("services.auto.opcional")), 1)
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                            id: "additional_information",
                            rows: "3",
                            maxlength: "255",
                            class: "block p-2.5 w-full text-sm bg-white rounded-lg border border-black focus:ring-blue-500 focus:border-blue-500",
                            placeholder: _ctx.$t('services.auto.ej_tiene_restricciones_alimenticias_requiere_asi'),
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(serviceForm).additional_information) = $event)),
                            disabled: isReadOnly.value
                        }, null, 8, _hoisted_95), [
                            [_vModelText, _unref(serviceForm).additional_information]
                        ])
                    ]),
                    _createVNode(ServiceChargesSection, {
                        "service-id": __props.service?.id ?? null,
                        "read-only": isReadOnly.value
                    }, null, 8, ["service-id", "read-only"])
                ])
            ]));
        };
    }
});
